import React from "react";
import { useSearchParams } from "react-router-dom";

import styles from "../../styles/AudioGenerator/AudioGenerator.module.scss";
import { UrlParameterNames } from "../../util/urlParameters";

import { EntryScreen } from "./EntryScreen/EntryScreen";
import { InputStyleScreen } from "./InputStyleScreen";
import { TargetServiceScreen } from "./TargetServiceScreen";

/* eslint-disable react/jsx-no-literals */

export type TargetService = "duolingo-tts" | "tts-generation-backend";
export type InputStyle = "single" | "bulk";

export interface AudioGenerationFlags {
  targetService: TargetService;
  inputStyle: InputStyle;
}

const ControlledFlow = ({
  children,
  curIndex,
}: {
  children: React.ReactNode | React.ReactNode[];
  curIndex: number;
}) => {
  const currentChild = React.Children.toArray(children)[curIndex];

  if (React.isValidElement(currentChild)) {
    return currentChild;
  }

  return <>{currentChild}</>;
};

export const AudioGenerator = () => {
  const [searchParams] = useSearchParams();
  const voiceParam = searchParams.get(UrlParameterNames.voice);
  const [flowData, setFlowData] = React.useState<Partial<AudioGenerationFlags>>(
    voiceParam
      ? { inputStyle: "single", targetService: "tts-generation-backend" }
      : {},
  );
  const [curScreenIndex, setCurScreenIndex] = React.useState(
    voiceParam ? 2 : 0,
  );

  const onNext = (stepData: Partial<AudioGenerationFlags>) => {
    setFlowData({ ...flowData, ...stepData });
    setCurScreenIndex(curScreenIndex + 1);
  };

  return (
    <div className={styles["container"]}>
      <h1>Audio Generator</h1>
      <ControlledFlow curIndex={curScreenIndex}>
        <TargetServiceScreen onNext={onNext} />
        <InputStyleScreen onNext={onNext} />
        <EntryScreen
          inputStyle={flowData.inputStyle}
          targetService={flowData.targetService}
          voiceParam={voiceParam}
        />
      </ControlledFlow>
    </div>
  );
};
